// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"8d23f244f21a762a","888":"e27e41b4b3d34bc4"}[chunkId] + ".css";
};